import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const customerRoutes = ({
  Appointment,
  CustomerSegmentation,
  DetailCustomerSegment,
  ContactSegmentation,
  DetailContactSegment,
  CustomerUnidentified,
  DetailCustomerUnidentified,
}: {
  Appointment: React.ComponentType;
  // customer segment
  CustomerSegmentation: React.ComponentType;
  DetailCustomerSegment: React.ComponentType;
  // Contact segment
  ContactSegmentation: React.ComponentType;
  DetailContactSegment: React.ComponentType;
  // Khách hàng chưa định danh
  CustomerUnidentified: React.ComponentType;
  DetailCustomerUnidentified: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.CUSTOMER.APPOINTMENT.BASE} element={<Appointment />} />
    {/* Customer segment */}
    <Route path={ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.BASE} element={<CustomerSegmentation />} />
    <Route path={ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.BASE} element={<DetailCustomerSegment />} />
    {/* Contact segment */}
    <Route path={ROUTES.CUSTOMER.CONTACT_SEGMENTATION.BASE} element={<ContactSegmentation />} />
    <Route path={ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.BASE} element={<DetailContactSegment />} />

    {/* Khách hàng chưa định danh */}
    <Route path={ROUTES.CUSTOMER.CUSTOMER_UNIDENTIFIED.BASE} element={<CustomerUnidentified />} />
    <Route path={ROUTES.CUSTOMER.CUSTOMER_UNIDENTIFIED.DETAIL.BASE} element={<DetailCustomerUnidentified />} />
  </Routes>
);
